export default "<app-userless-header></app-userless-header>\r\n<router-outlet></router-outlet>\r\n<app-footer></app-footer>"